document.addEventListener('DOMContentLoaded', function () {
  const dropdownSlider = document.querySelectorAll('.ed-header .dropdown-slider');

  dropdownSlider.forEach((collection) => {
    const swiperContainer = collection.querySelector('.swiper');
    let swiperInstance;

    const initializeSwiper = () => {
      // Check if any image has the landscape class
      const hasLandscapeImages = collection.querySelector('img.landscape');
      const slidesPerView = hasLandscapeImages ? 1.25 : 2.5;

      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: slidesPerView,
        spaceBetween: 8,
      });
    };

    const handleBreakpointChange = () => {
      const viewportWidth = window.innerWidth;

      if (viewportWidth >= 990) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true); // Destroy the Swiper instance
          swiperInstance = null;
        }
      } else if (!swiperInstance) {
        initializeSwiper(); // Reinitialize if needed
      }
    };

    // Initialize on load
    handleBreakpointChange();

    // Add event listener to handle window resize
    window.addEventListener('resize', handleBreakpointChange);
  });
});
